<template>
  <section id="invitation-background" class="section no-padding-mobile">
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="false"
    ></b-loading>
    <div
      class="columns is-centered"
      style="background-image: url('~@/assets/invitation_background.jpg') !important;"
    >
      <div class="column is-6-desktop no-padding-mobile">
        <div id="invitation-container">
          <div id="title" class="container">
            <h4 class="title is-4 is-pink">
              {{ $t('Verifique su codigo de Invitacion') }}
            </h4>
          </div>
          <div id="code-input-area" class="postScriptum container is-full-w">
            <ValidationObserver v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(submitInvitationCode)">
                <b-field grouped multiline>
                  <ValidationProvider
                    name="Invitation Code"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <b-input
                      v-model="invitationCode"
                      :placeholder="$t('Codigo')"
                    />
                    <p v-show="errors.length" class="help is-danger">
                      {{ errors[0] }}
                    </p>
                  </ValidationProvider>

                  <b-button native-type="submit" class="is-primary">
                    {{ $t('Verificar') }}
                  </b-button>
                </b-field>
              </form>
            </ValidationObserver>
          </div>
          <div v-if="!submitted" id="invitation-request-area">
            <div class="container">
             <h4 class="title is-4 is-pink">
              {{ $t('Solicitar codigo de Invitacion') }}
            </h4>
              <br />
              <p>
                *{{
                  $t(
                    'Si usted no tiene su código de invication puede solicitarlo rellenenando el siguiente formulario'
                  )
                }}
              </p>
              <br />
              <div class="field">
                <b-radio v-model="clientType" native-value="client"
                  >{{ $t('Busco capital para mi proyecto') }}
                  <a style="color: #ee588d;" @click="showOptionInfo('Busco_capital_para_mi_empresa')"
                    ><b-icon icon="help-circle"
                  /></a>
                </b-radio>
              </div>
              <div class="field">
                <b-radio v-model="clientType" native-value="partner"
                  >{{ $t('Estoy interesado en ser partner de Ecobanka') }}
                  <a
                    style="color: #ee588d;"
                    @click="
                      showOptionInfo(
                        'Busco_capital_para_empresas_a_las_que_represento'
                      )
                    "
                    ><b-icon icon="help-circle"
                  /></a>
                </b-radio>

              </div>

              <ValidationObserver v-slot="{ handleSubmit }">
                <form @submit.prevent="handleSubmit(submitRequestInvitation)">
                  <b-field grouped group-multiline>
                    <b-field expanded :label="$t('Nombre') + '*'">
                      <ValidationProvider
                        name="Nombre"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <b-input v-model="requestInvitationForm.firstName" />
                        <p v-show="errors.length" class="help is-danger">
                          {{ errors[0] }}
                        </p>
                      </ValidationProvider>
                    </b-field>
                    <b-field expanded :label="$t('Apellidos') + '*'">
                      <ValidationProvider
                        name="Apellidos"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <b-input v-model="requestInvitationForm.lastName" />
                        <p v-show="errors.length" class="help is-danger">
                          {{ errors[0] }}
                        </p>
                      </ValidationProvider>
                    </b-field>
                  </b-field>
                  <b-field grouped group-multiline>
                    <b-field expanded :label="$t('Email') + '*'">
                      <ValidationProvider
                        name="Email"
                        rules="required|email"
                        v-slot="{ errors }"
                      >
                        <b-input v-model="requestInvitationForm.email" />
                        <p v-show="errors.length" class="help is-danger">
                          {{ errors[0] }}
                        </p>
                      </ValidationProvider>
                    </b-field>
                    <b-field expanded label="Red Social">
                      <b-input
                        expanded
                        v-model="requestInvitationForm.socialNetwork"
                      ></b-input>
                    </b-field>
                  </b-field>

                  <b-field
                    grouped
                    group-multiline
                    v-if="clientType == 'partner'"
                  >
                    <b-field expanded :label="$t('Profesión') + '*'">
                      <ValidationProvider
                        name="Profession"
                        rules="required|alpha"
                        v-slot="{ errors }"
                      >
                        <b-input
                          expanded
                          v-model="requestInvitationForm.jobPosition"
                        ></b-input>
                        <p v-show="errors.length" class="help is-danger">
                          {{ errors[0] }}
                        </p>
                      </ValidationProvider>
                    </b-field>

                    <b-field expanded :label="$t('Teléfono') + '*'">
                      <ValidationProvider
                        name="Teléfono"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <VuePhoneNumberInput
                          v-model="telephone"
                          @update="phoneUpdated"
                        />
                        <p v-show="errors.length" class="help is-danger">
                          {{ errors[0] }}
                        </p>
                      </ValidationProvider>
                    </b-field>
                  </b-field>

                  <b-field
                    grouped
                    group-multiline
                    v-if="clientType == 'partner'"
                  >
                    <b-field
                      expanded
                      :label="$t('Dirección / Ubicación') + '*'"
                    >
                      <ValidationProvider
                        name="Ubicacion"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <b-input v-model="requestInvitationForm.location" />
                        <p v-show="errors.length" class="help is-danger">
                          {{ errors[0] }}
                        </p>
                      </ValidationProvider>
                    </b-field>
                  </b-field>
                  <b-field :label="$t('Comentarios')">
                    <b-input
                      type="textarea"
                      v-model="requestInvitationForm.comments"
                    />
                  </b-field>
                  <b-field>
                    <ValidationProvider
                      name="Terminos de uso"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <b-checkbox v-model="requestInvitationForm.accept">
                        <a
                          href="https://ecobanka.com/privacy-policy%E2%80%8B/"
                          target="_blank"
                        >
                          {{
                            $t(
                              'Acepto la Política de Privacidad, Términos y Condiciones'
                            )
                          }} </a
                        >*
                      </b-checkbox>
                      <p v-show="errors.length" class="help is-danger">
                        {{ $t('Debes aceptar los términos y condiciones') }}
                      </p>
                    </ValidationProvider>
                  </b-field>
                  <b-field>
                    <b-checkbox v-model="requestInvitationForm.newsletter">{{
                      $t('Quiero suscribirme al Newsletter')
                    }}</b-checkbox>
                  </b-field>
                  <div class="buttons">
                    <b-button
                      class="is-primary is-medium"
                      style="float:right;"
                      native-type="submit"
                      >{{ $t('Solicitar') }}</b-button
                    >
                  </div>
                </form>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import { mapActions } from 'vuex'
import Fetcher from '@/mixins/fetcher.js'
import SuccessModal from '@/components/on-board/SuccessModal'

import {
  required,
  alpha,
  numeric,
  email,
  confirmed
} from 'vee-validate/dist/rules'

extend('required', {
  ...required
})

extend('alpha', {
  ...alpha
})

extend('numeric', {
  ...numeric
})

extend('email', {
  ...email
})

extend('confirmed', {
  ...confirmed
})

export default {
  mixins: [Fetcher],
  components: {
    ValidationProvider,
    ValidationObserver,
    VuePhoneNumberInput
  },
  data() {
    return {
      submitted: false,
      invitationCode: null,
      clientType: 'client',
      telephone: null,
      requestInvitationForm: {
        firstName: null,
        lastName: null,
        email: null,
        location: null,
        telephone: null,
        jobPosition: null,
        comments: null,
        subscription: null,
        socialNetwork: null,
        accept: null,
        newsletter: null
      }
    }
  },
  mounted() {
    this.$jbUtils.toggle(false)
    this.$store.commit('layout/FULL_PAGE', true)
  },
  methods: {
    ...mapActions('invitationCode', [
      'getInvitationCodeDetails',
      'postRequestInvitation'
    ]),
    showOptionInfo(option) {
      let self = this
      self.$dlg.modal(SuccessModal, {
        shaking: false,
        title: false,
        params: {
          title: self.$t(`${option}_info_title`),
          bgColor: '#de4281',
          content: `<p>${self.$t(`${option}_info_content`)}</p>`,
          confirmText: self.$t('Aceptar')
        }
      })
    },
    goToNeofintech() {
      this.$router.push({ name: 'onBoard.neofintech.phase1.1' })
    },
    goToLogin() {
      this.$router.push({ name: 'sign-in' })
    },
    phoneUpdated(val) {
      this.requestInvitationForm.telephone = val.formatInternational
    },
    submitRequestInvitation: function() {
      let self = this
      self.request(() =>
        self
          .postRequestInvitation({
            ...{ clientType: self.clientType },
            ...{ lang: self.$i18n.locale },
            ...self.requestInvitationForm
          })
          .then(function() {
            self.$dlg.modal(SuccessModal, {
              shaking: false,
              title: false,
              params: {
                title: self.$t('Gracias por su información'),
                bgColor: '#de4281',
                content:
                  self.clientType == 'client'
                    ? `<p>${self.$t(
                        'Revise la bandeja de entrada de su email.'
                      )}</p><p>${self.$t(
                        'Nuestro Director o Ejecutivo corporativo de su zona, le enviará inmediatamente el código de verificación para iniciar su solicitud.'
                      )}</p>`
                    : `<p>${self.$t(
                        'Revise la bandeja de entrada de su email.'
                      )}</p><p>${self.$t(
                        'Nuestro Director o Ejecutivo corporativo de su zona, le enviará inmediatamente el código de invitación cuando revise su solicitud.'
                      )}</p>`,
                confirmText: self.$t('Aceptar')
              }
            })
            self.submitted = true
          })
      )
    },
    submitInvitationCode: function() {
      let self = this
      self.request(() =>
        self
          .getInvitationCodeDetails(self.invitationCode)
          .then(function(response) {
            if (response.data.PK) {
              if (response.data.SK.charAt(0) == 'C') {
                self.goToNeofintech()
              } else {
                self.$dlg.modal(SuccessModal, {
                  shaking: false,
                  title: false,
                  params: {
                    title: self.$t('Su código ha sido verificado'),
                    bgColor: '#de4281',
                    content: `<p>${self.$t(
                      'Revise la bandeja de entrada de su email, allí encontrará sus credenciales temporales para iniciar sesión'
                    )}</p>`,
                    confirmText: self.$t('Aceptar')
                  },
                  callback: () => {
                    self.goToLogin()
                  }
                })
              }
            } else {
              self.$toast.open({
                message: self.$t('Código no válido'),
                type: 'error'
              })
            }
          })
      )
    }
  }
}
</script>

<style lang="scss">
#invitation-background {
  min-height: 100%;
  background-image: url('~@/assets/invitation_background.jpg');
  background-size: 120%;
  background-repeat: no-repeat;
  background-position-y: bottom;
  background-position-x: center;
}
#invitation-container {
  margin: auto;
  background: #ffffff;
  overflow: hidden;
  border: solid 2px var(--rosa-dark-eco);
  border-radius: 40px;
  box-shadow: 0 5px 15px #00000044;

  > div {
    align-self: center;
    padding: 40px;
  }

  #code-input-area {
    font-size: 20px;
    display: flex;
    height: 100%;
    background: linear-gradient(var(--rosa-eco), var(--rosa-dark-eco));
    box-shadow: 0 5px 20px -10px;

    > * {
      margin: auto;
    }
  }

  #invitation-request-area {
    overflow: scroll;
    height: 100%;
  }
}

/** Fix telefono altura/margen inferior */
#MazPhoneNumberInput {
  margin-bottom: 20px;
}
</style>
